import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Auto-register Stimulus controllers defined alongside ViewComponents under
// app/components/ui/<component>_component/<component>_component_controller.js.
// Identifier convention: strip the `_controller.js` suffix and convert
// underscores to hyphens. E.g. `timer_button_component_controller.js` ->
// `timer-button-component`.
const context = require.context( // eslint-disable-line no-undef
  '../../components/ui',
  true,
  /_controller\.js$/,
);

context.keys().forEach((key) => {
  const mod = context(key);
  const filename = key.split('/').pop();
  const identifier = filename
    .replace(/_controller\.js$/, '')
    .replace(/_/g, '-');

  if (mod && mod.default) {
    application.register(identifier, mod.default);
  }
});

export default application;
